/** Safely inspect an Axios-style response status without coupling callers to Axios. */
export function hasHttpStatus(error: unknown, status: number): boolean {
  return (
    typeof error === "object" &&
    error !== null &&
    "response" in error &&
    (error as { response?: { status?: number } }).response?.status === status
  );
}

export function responseError(error: unknown, fallback: string): string {
  if (typeof error !== "object" || error === null || !("response" in error)) {
    return fallback;
  }
  const response = (error as { response?: { data?: { error?: unknown } } })
    .response;
  return typeof response?.data?.error === "string"
    ? response.data.error
    : fallback;
}
